var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHomeOutline = function SvgHomeOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    "data-name": "Home empty"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5d5d5d",
    d: "m10 3.095-3.488 3.14-3.075 2.766h1.179v8h3.09V12.91c0-1.125.953-1.942 2.265-1.942.53 0 1.043.14 1.444.396.558.355.878.918.878 1.546V17h3.09V9.001h1.178L10 3.095m0-1.094c.174 0 .348.062.486.187l7.273 6.546a.727.727 0 0 1-.487 1.267h-.888v7.272a.728.728 0 0 1-.728.728H12.02a.728.728 0 0 1-.727-.728v-4.362c0-1.218-2.586-1.293-2.586 0v4.363a.728.728 0 0 1-.728.728H4.343a.728.728 0 0 1-.727-.728v-7.27h-.889a.728.728 0 0 1-.486-1.27l7.272-6.545A.724.724 0 0 1 10 2.001z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.759 8.734-7.273-6.546a.726.726 0 0 0-.973 0L2.241 8.734a.727.727 0 0 0 .486 1.267h.889v7.271a.728.728 0 0 0 .727.729h3.636a.728.728 0 0 0 .727-.727V12.91c0-1.293 2.586-1.218 2.586 0v4.364a.728.728 0 0 0 .728.727h3.636a.728.728 0 0 0 .727-.727v-7.273h.889a.727.727 0 0 0 .487-1.268z"
  }))));
};
export default SvgHomeOutline;